const root = 'StoreProfilePage'

export const TestId = {
  root,
  title: `${root}-title`,
}
